// extracted by mini-css-extract-plugin
export default {"box":"NewNoteButton_box__wWYFk","btn":"NewNoteButton_btn__zsE0r","btn_show":"NewNoteButton_btn_show__RVFsc","btn__number":"NewNoteButton_btn__number__EkR-V"};